import Image from 'next/image'
import whyNotDeliLogo from './whynotdeli.png'

type IconProps = {
  className?: string
}

const WhyNotDeliLogo: React.FC<IconProps> = ({ ...attributes }) => {
  return <Image src={whyNotDeliLogo} alt="Why Not Deli Logo" height={48} {...attributes} />
}

export default WhyNotDeliLogo
